import api from './apiService'
import { ROLES } from '../permissions/roles'

// ─── Hotels ──────────────────────────────────────────────────────────────────

export const saveWebDevice = (onesignal_id) => api.put('/admin/me/web-device', { onesignal_id })

export const listHotels    = ()              => api.get('/admin/hotels')
export const getHotel      = (id)            => api.get(`/admin/hotels/${id}`)
export const createHotel   = (data)          => api.post('/admin/hotels', data)
export const updateHotel   = (id, data)      => api.put(`/admin/hotels/${id}`, data)
export const deleteHotel   = (id)            => api.delete(`/admin/hotels/${id}`)
export const setHotelTestFlag = (id, isTest) => api.put(`/admin/hotels/${id}/test-flag`, { is_test: isTest })
export const updateHotelLocation = (id, data) => api.put(`/admin/hotels/${id}/location`, data)

// ─── Locations ───────────────────────────────────────────────────────────────

export const listLocations    = (hotelId)       => api.get(`/admin/hotels/${hotelId}/locations`)
export const getLocation      = (id)            => api.get(`/admin/locations/${id}`)
export const createLocation   = (hotelId, data) => api.post(`/admin/hotels/${hotelId}/locations`, data)
export const updateLocation   = (id, data)      => api.put(`/admin/locations/${id}`, data)
export const deleteLocation   = (id)            => api.delete(`/admin/locations/${id}`)
// Mapa recursivo (spec #148, ticket #149): mapPoints continua sendo o
// contorno da região; parentLocationId/point (opcionais) são a posição desse
// Local dentro da região do PAI, quando esse Local vive num sub-mapa.
export const updateLocationMapPoints = (id, mapPoints, parentLocationId = null, point = null) =>
  api.put(`/admin/locations/${id}/map-points`, { mapPoints, parentLocationId, point })

// Ticket #209: histórico de edições do mapa (região, autor, data) na própria
// tela de Mapa -- reaproveita a mesma fonte do visualizador is_dev
// (listMapActions abaixo), mas escopado por hotel/GESTAO, sem depender de is_dev.
export const listMapActionsHistory = (hotelId, params = {}) =>
  api.get('/admin/map-actions/history', { params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...params } })

// Atribuir atividade a uma região (spec #148, ticket #150) -- substitui o
// Ponto fixo por atividade (ADR-0014, descontinuado): só o local padrão,
// sem coordenada.
export const listLocationActivities  = (locationId) => api.get(`/admin/locations/${locationId}/activities`)

// Cadeia de ancestrais até o Local informado, inclusive (spec #148, ticket
// #257) -- alimenta o LocationBreadcrumb no editor de mapa, reaproveitando
// a mesma CTE recursiva (findLocationChain) já usada pela proteção contra
// ciclo no backend.
export const getLocationChain = (locationId) => api.get(`/admin/locations/${locationId}/chain`)
export const setLocationActivity     = (locationId, activityTypeId) => api.put(`/admin/locations/${locationId}/activities/${activityTypeId}`)
export const removeLocationActivity  = (locationId, activityTypeId) => api.delete(`/admin/locations/${locationId}/activities/${activityTypeId}`)

// ─── Activity Types ───────────────────────────────────────────────────────────

// `includeInactive` (ticket #135, spec #130): por padrão o backend só
// devolve ativas -- é o que os dropdowns de seleção (Programação,
// MapRegionEditor, tag de vídeo) querem. AtividadesView (catálogo) e
// AtividadesDetailView (detalhe/edição) passam true, pra continuar
// enxergando/auditando entradas já fundidas (ticket #137).
export const listActivityTypes         = ({ page = 1, limit = 50, search, includeInactive } = {}) =>
  api.get('/admin/activity-types', { params: { page, limit, ...(search ? { search } : {}), ...(includeInactive ? { includeInactive: true } : {}) } })
export const createActivityType        = (data)               => api.post('/admin/activity-types', data)
export const updateActivityType        = (id, data)           => api.put(`/admin/activity-types/${id}`, data)
export const deleteActivityType        = (id)                 => api.delete(`/admin/activity-types/${id}`)
export const setHotelActivityEnergy    = (id, hotelId, energy) => api.put(`/admin/activity-types/${id}/hotel-energy/${hotelId}`, { energy })
export const removeHotelActivityEnergy = (id, hotelId)        => api.delete(`/admin/activity-types/${id}/hotel-energy/${hotelId}`)
export const setHotelActivityDuration    = (id, hotelId, durationMinutes) => api.put(`/admin/activity-types/${id}/hotel-duration/${hotelId}`, { duration_minutes: durationMinutes })
export const removeHotelActivityDuration = (id, hotelId)                  => api.delete(`/admin/activity-types/${id}/hotel-duration/${hotelId}`)
// Ticket #137 (spec #130): fusão de duplicatas -- admin-only no backend (SUPER).
export const mergeActivityTypes = (principalId, duplicateId) =>
  api.post('/admin/activity-types/merge', { principalId, duplicateId })
// Ticket #138: resumo do impacto pra tela de confirmação, antes de fundir.
export const getActivityTypeMergePreview = (principalId, duplicateId) =>
  api.get('/admin/activity-types/merge/preview', { params: { principalId, duplicateId } })

// ─── Class Types ──────────────────────────────────────────────────────────────

export const listClassTypes    = ({ page = 1, limit = 50, search } = {}) =>
  api.get('/admin/class-types', { params: { page, limit, ...(search ? { search } : {}) } })
export const createClassType   = (data)     => api.post('/admin/class-types', data)
export const updateClassType   = (id, data) => api.put(`/admin/class-types/${id}`, data)
export const getClassTypeExceptionImpact = (id, data) => api.post(`/admin/class-types/${id}/exception-impact`, data)
export const deleteClassType   = (id)       => api.delete(`/admin/class-types/${id}`)

// ─── Classes ─────────────────────────────────────────────────────────────────

export const listClasses           = (hotelId, fromDate)       => api.get('/admin/classes', { params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...(fromDate ? { from_date: fromDate } : {}) } })
// Turma única, sem os filtros de hotel/data de listClasses -- usado ao abrir
// a Programação direto por um link com turma_id.
export const getClass              = (id)            => api.get(`/admin/classes/${id}`)
export const createClass           = (data)          => api.post('/admin/classes', data)
export const updateClass           = (id, data)      => api.put(`/admin/classes/${id}`, data)
export const deleteClass           = (id)            => api.delete(`/admin/classes/${id}`)
export const setEvaluationTime     = (id, evaluation_opens_at) => api.patch(`/admin/classes/${id}/evaluation-time`, { evaluation_opens_at })
export const setAdherenceGoal      = (id, adherence_goal)      => api.patch(`/admin/classes/${id}/adherence-goal`, { adherence_goal })
export const getLastActivityTime   = (id)            => api.get(`/admin/classes/${id}/last-activity-time`)
export const setClassNotes         = (id, notes)     => api.patch(`/admin/classes/${id}/notes`, { notes })
export const getClassConflicts     = (id)            => api.get(`/admin/classes/${id}/conflicts`)
export const getClassChildren      = (id)            => api.get(`/admin/classes/${id}/children`)
// Lotes de saída da chamada e restauração (ADR-0040): exitedAt vai de volta exatamente como o servidor devolveu.
export const listExitBatches      = (classId)       => api.get(`/admin/classes/${classId}/exit-batches`)
export const restoreExitBatch     = (classId, data) => api.post(`/admin/classes/${classId}/exit-batches/restore`, data)

// ─── Activities ──────────────────────────────────────────────────────────────

export const listActivities    = (classId)    => api.get('/admin/activities', { params: { class_id: classId } })
export const listActivitiesByHotel = ({ hotelId, date, status }) =>
  api.get('/admin/activities', { params: { hotel_id: hotelId, date, ...(status ? { status } : {}) } })
export const listActivitiesByClass = ({ classId, date, status }) =>
  api.get('/admin/activities', { params: { class_id: classId, date, ...(status ? { status } : {}) } })
export const getClassTodaySummary = (classId) => api.get(`/admin/classes/${classId}/today-summary`)
export const getActivity       = (id)         => api.get(`/admin/activities/${id}`)
export const createActivity    = (data)       => api.post('/admin/activities', data)
export const updateActivity    = (id, data)   => api.put(`/admin/activities/${id}`, data)
export const deleteActivity    = (id)         => api.delete(`/admin/activities/${id}`)
export const setActivityNotes  = (id, notes)  => api.patch(`/admin/activities/${id}/notes`, { notes })
export const getActivityStats  = (id)         => api.get(`/admin/activities/${id}/stats`)

// ─── Roles ───────────────────────────────────────────────────────────────────

export const listRoles = () => api.get('/admin/roles')

// ─── Employees ───────────────────────────────────────────────────────────────

export const listEmployees          = (hotelId)        => api.get('/admin/employees',      { params: hotelId ? { hotel_id: hotelId } : {} })
export const listEmployeesFull      = ({ hotelId, page = 1, limit = 50, search, role, status } = {}) =>
  api.get('/admin/employees/all', {
    params: {
      page, limit,
      ...(hotelId ? { hotel_id: hotelId } : {}),
      ...(search ? { search } : {}),
      ...(role ? { role } : {}),
      ...(status ? { status } : {}),
    },
  })
export const createEmployee         = (data)           => api.post('/admin/employees', data)
export const updateEmployee         = (id, data)       => api.put(`/admin/employees/${id}`, data)
export const deleteEmployee         = (id)             => api.delete(`/admin/employees/${id}`)
export const resetEmployeePassword  = (id, newPassword) => api.put(`/admin/employees/${id}/reset-password`, { newPassword })
export const getEmployeePassword    = (id)             => api.get(`/admin/employees/${id}/password`)
export const setEmployeeDev         = (id, isDev)      => api.put(`/admin/employees/${id}/dev`, { is_dev: isDev })

// ─── Account Holders ─────────────────────────────────────────────────────────

export const listAccountHolders     = (params)   => api.get('/admin/account-holders', { params })
export const createAccountHolder    = (data)     => api.post('/admin/account-holders', data)
// [T4] ticket #280 -- conta de hóspede de TESTE via Taualegres, sem SMS/OTP
// (Admin/Gerente definem a senha na hora). Restrito a admin/manager no backend.
export const createTestAccountHolder = (data)    => api.post('/admin/account-holders/test', data)
// #232 -- Central de Ativação: jornada das contas até o primeiro acesso no app.
export const getActivationCentral = (params) => api.get('/admin/activation', { params })
// #366 -- painel de contas de teste (is_test = true).
export const listTestAccountHolders = (params) => api.get('/admin/account-holders/test', { params })
// Log do que mudou nas contas de teste (quem, quando, campo antigo -> novo).
export const listTestAccountLogs = (params) => api.get('/admin/account-holders/test/logs', { params })
// Contas reais (ativas e inativas) que podem virar conta de teste -- busca no nosso banco.
export const searchTestCandidates = ({ search, page, limit } = {}) =>
  api.get('/admin/account-holders/test-candidates', { params: { search, page, limit } })
// Liga o modo teste numa conta real: { password, checkinAt, checkoutAt, hotelId? }.
export const convertToTestAccount = (id, payload) => api.post(`/admin/account-holders/${id}/test-mode`, payload)
// Filhos da conta de teste (alvo da concessão de energia) -- único ponto a re-apontar se o endpoint mudar.
export const getTestAccountChildren = (id) => api.get(`/admin/account-holders/${id}/test-children`)
export const updateAccountHolder    = (id, data) => api.put(`/admin/account-holders/${id}`, data)
// Histórico (só leitura) das correções de documento da conta; mais recente primeiro.
export const getAccountHolderDocumentHistory = (id) => api.get(`/admin/account-holders/${id}/document-history`)
// Transferir a família para outro hotel: operação única do backend (hotelId, roomNumber, checkinAt, checkoutAt).
export const transferAccountHolderHotel = (id, data) => api.post(`/admin/account-holders/${id}/transfer-hotel`, data)
// Consulta a VOLUX do hotel de destino (quarto e período da hospedagem) para preencher a transferência.
// `document` só vale quando a conta não tem documento guardado.
export const lookupTransferStay = (id, { hotelId, document } = {}) =>
  api.post(`/admin/account-holders/${id}/transfer-stay-lookup`, document ? { hotelId, document } : { hotelId })
// Vincula RFID ao hóspede titular ("Vincular pulseira" em Contas de Teste, #149).
export const linkAccountHolderRfid  = (id, rfid) => api.patch(`/admin/account-holders/${id}/rfid`, { rfid })
// Desvincular pulseira (componente de pulseira, spec #150 / #153).
export const unlinkAccountHolderRfid = (id) => api.delete(`/admin/account-holders/${id}/rfid`)
export const unlinkChildRfid         = (id) => api.delete(`/admin/children/${id}/rfid`)
export const unlinkGuardianRfid      = (id) => api.delete(`/admin/guardians/${id}/rfid`)
export const deleteAccountHolder    = (id)       => api.delete(`/admin/account-holders/${id}`)
export const listAccountHolderStays = (id)       => api.get(`/admin/account-holders/${id}/stays`)
// #231 -- card de atendimento: status de ativação, origem e último acesso.
export const getAccountHolderSupport = (id)      => api.get(`/admin/account-holders/${id}/support`)
// Admin-dev only (backend valida via requireDev) -- zera a senha pra testar o fluxo de "primeiro acesso".
export const resetAccountHolderPassword = (id)   => api.put(`/admin/account-holders/${id}/reset-password`)
// Admin-dev only -- define uma senha específica pro hóspede, sem passar pela ativação.
export const setAccountHolderPassword   = (id, newPassword) => api.put(`/admin/account-holders/${id}/set-password`, { newPassword })

// ─── Volux ───────────────────────────────────────────────────────────────────

export const registerFromVolux   = (data)                  => api.post('/admin/account-holders/from-volux', data)

// ─── Guardians ───────────────────────────────────────────────────────────────

export const listGuardians   = (params)      => api.get('/admin/guardians', { params })
export const createGuardian  = (data)        => api.post('/admin/guardians', data)
export const updateGuardian  = (id, data)    => api.put(`/admin/guardians/${id}`, data)
export const moveGuardian    = (id, accountHolderId) => api.put(`/admin/guardians/${id}/move`, { account_holder_id: accountHolderId })
export const deleteGuardian  = (id)          => api.delete(`/admin/guardians/${id}`)

// ─── Co-responsável (ADR-0020, L7-04) ──────────────────────────────────────────

export const separateCoResponsavel = (primaryAccountHolderId, skipChildIds) =>
  api.post('/admin/co-responsavel/separate', { primaryAccountHolderId, skipChildIds })

// ─── Children ────────────────────────────────────────────────────────────────

export const listChildren            = (params)    => api.get('/admin/children', { params })
export const getChildDetail          = (id)        => api.get(`/admin/children/${id}`)
export const createChild             = (data)      => api.post('/admin/children', data)
export const updateChild             = (id, data)  => api.put(`/admin/children/${id}`, data)
export const deleteChild             = (id)        => api.delete(`/admin/children/${id}`)

// ─── Notifications ────────────────────────────────────────────────────────────

// "Todos os hotéis" (hotelId ausente no push / audience_type "all" na
// notificação) passa a exigir role admin (ADR-0011, ticket #106) -- manager
// fica obrigado a escolher um hotel específico. Checado aqui, não só
// escondido na UI, mesmo padrão do backend em admin.controller.ts.
function assertHotelSelectionAllowed(role, isAllHotels) {
  if (isAllHotels && role !== ROLES.ADMIN) {
    throw new Error('Apenas administradores podem enviar para "Todos os hotéis" -- escolha um hotel específico.')
  }
}

// Log de criação de Missões e Desafios do Dia (ticket L1-05).
export const getCreationLog = (hotelId) => api.get('/admin/creation-log', { params: { hotel_id: hotelId } })

export const listNotifications  = (params) => api.get('/admin/notifications', { params })
export const getNotification    = (id)     => api.get(`/admin/notifications/${id}`)

export const createNotification = (data, role) => {
  assertHotelSelectionAllowed(role, data.audience_type === 'all')
  return api.post('/admin/notifications', data)
}

// Ticket #214: só notificações ainda 'scheduled' podem ser editadas -- o
// backend rejeita (409) quem já foi enviada/cancelada, mesmo que a UI já
// esconda a ação nesses casos (ver canEdit em notificacoes.js).
export const updateNotification = (id, data) => api.put(`/admin/notifications/${id}`, data)

// Rota continua DELETE por compatibilidade (ver taua-backend#59), mas o
// backend cancela (status='cancelled') em vez de apagar -- a notificação
// permanece visível na listagem.
export const cancelNotification = (id) => api.delete(`/admin/notifications/${id}`)

export const sendPushNotification = (data, role) => {
  assertHotelSelectionAllowed(role, data.hotelId == null)
  return api.post('/admin/notifications/push', data)
}

// ─── Notification Templates (ticket #214) ──────────────────────────────────────
// Biblioteca de avisos reutilizáveis -- só conteúdo (título/mensagem/tipo/
// imagem), sem audiência/agendamento (escolhidos a cada envio).
export const listNotificationTemplates  = ()     => api.get('/admin/notification-templates')
export const createNotificationTemplate = (data) => api.post('/admin/notification-templates', data)
export const deleteNotificationTemplate = (id)   => api.delete(`/admin/notification-templates/${id}`)

// ─── Missions ────────────────────────────────────────────────────────────────

export const listMissions           = (params)             => api.get('/admin/missions', { params })
// Ticket L1-06: drag-and-drop -- lista completa de ids na nova ordem.
export const reorderMissions        = (orderedIds)          => api.put('/admin/missions/reorder', { orderedIds })
export const getMissionCompletionStats = (hotelId)         => api.get('/admin/missions/completion-stats', { params: hotelId ? { hotel_id: hotelId } : {} })
export const getMissionCompletionHistory = ({ from, to, hotelId, validationType } = {}) =>
  api.get('/admin/missions/completion-history', { params: {
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(hotelId ? { hotel_id: hotelId } : {}),
    ...(validationType ? { validation_type: validationType } : {}),
  } })
export const getMission             = (id)                 => api.get(`/admin/missions/${id}`)
export const createMission          = (data)               => api.post('/admin/missions', data)
export const updateMission          = (id, data)           => api.put(`/admin/missions/${id}`, data)
export const deleteMission          = (id)                 => api.delete(`/admin/missions/${id}`)
export const duplicateMission       = (id, data)           => api.post(`/admin/missions/${id}/duplicate`, data)
export const listMissionQrCodes     = (missionId)          => api.get(`/admin/missions/${missionId}/qr-codes`)
export const addMissionQrCode       = (missionId, data)    => api.post(`/admin/missions/${missionId}/qr-codes`, data)
export const deleteMissionQrCode    = (missionId, codeId)  => api.delete(`/admin/missions/${missionId}/qr-codes/${codeId}`)
// Nomes duplos dos QR Codes (Substantivo + Adjetivo + sufixo)
export const getQrNames             = ()                   => api.get('/admin/qr-names')
export const addQrNameWord          = (data)               => api.post('/admin/qr-names/words', data)
export const deleteQrNameWord       = (id)                 => api.delete(`/admin/qr-names/words/${id}`)
export const updateQrNameSuffix     = (suffix)             => api.put('/admin/qr-names/suffix', { suffix })
export const listMissionCompletions = (missionId)          => api.get(`/admin/missions/${missionId}/completions`)
export const listPhotoSubmissions   = (status, hotelId)    => api.get('/admin/missions/photo-submissions', { params: { status, hotel_id: hotelId || undefined } })
export const approvePhotoSubmission = (id)                 => api.post(`/admin/missions/photo-submissions/${id}/approve`)
export const rejectPhotoSubmission  = (id, reason)         => api.post(`/admin/missions/photo-submissions/${id}/reject`, { reason })

// ─── Ranks ───────────────────────────────────────────────────────────────────

export const listRanks  = ()          => api.get('/admin/ranks')
export const createRank = (data)      => api.post('/admin/ranks', data)
export const updateRank = (id, data)  => api.put(`/admin/ranks/${id}`, data)
export const deleteRank = (id)        => api.delete(`/admin/ranks/${id}`)
// Ticket L1-13: preview de impacto e histórico de mudanças de faixa.
export const getRankUpdateImpact = (id, minEnergy, maxEnergy) => api.post(`/admin/ranks/${id}/impact`, { min_energy: minEnergy, max_energy: maxEnergy })
export const getRankDeleteImpact = (id)                       => api.get(`/admin/ranks/${id}/delete-impact`)
export const getRankHistory      = ()                          => api.get('/admin/ranks/history')

// Aviso de Evolução de Patente (spec #265, ticket #267) -- GESTAO (Admin +
// Gerente), diferente do CRUD de patente acima.
export const listRankPromotions = ({ hotelId, status, rankId, from, to, page = 1, limit = 20 } = {}) =>
  api.get('/admin/rank-promotions', { params: {
    ...(hotelId ? { hotel_id: hotelId } : {}),
    ...(status ? { status } : {}),
    ...(rankId ? { rank_id: rankId } : {}),
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    page, limit,
  } })
export const updateRankPromotionStatus = (id, status) => api.patch(`/admin/rank-promotions/${id}/status`, { status })
export const getPendingRankPromotionsCount = (hotelId) =>
  api.get('/admin/rank-promotions/pending-count', { params: hotelId ? { hotel_id: hotelId } : {} })

// ─── Taualegres ───────────────────────────────────────────────────────────────

export const listTaualegres          = ({ hotelId, page = 1, limit = 50, search, status } = {}) =>
  api.get('/admin/taualegres', {
    params: {
      page, limit,
      ...(hotelId ? { hotel_id: hotelId } : {}),
      ...(search ? { search } : {}),
      ...(status ? { status } : {}),
    },
  })
export const getTaualegre            = (id)             => api.get(`/admin/taualegres/${id}`)
export const createTaualegre         = (data)           => api.post('/admin/taualegres', data)
export const updateTaualegre         = (id, data)       => api.put(`/admin/taualegres/${id}`, data)
export const deleteTaualegre         = (id)             => api.delete(`/admin/taualegres/${id}`)
export const setTaualegrePassword    = (id, password)   => api.put(`/admin/taualegres/${id}/password`, { password })
export const getTaualegrePin         = (id)             => api.get(`/admin/taualegres/${id}/pin`)

// Senha mestra (migration 196) -- restrita a admin com a flag is_dev (checado no backend).
export const setTaualegreMasterPassword       = (password) => api.put('/admin/taualegres/master-password', { password })
export const getTaualegreMasterPassword       = ()          => api.get('/admin/taualegres/master-password')
export const getTaualegreMasterPasswordStatus = ()          => api.get('/admin/taualegres/master-password/status')

// ─── Rankings ─────────────────────────────────────────────────────────────────

export const listRankings             = (hotelId)        => api.get('/admin/rankings', { params: hotelId ? { hotel_id: hotelId } : {} })
export const createRanking            = (data, hotelId)  => api.post('/admin/rankings', data, { params: hotelId ? { hotel_id: hotelId } : {} })
export const updateRanking            = (id, data, hotelId) => api.patch(`/admin/rankings/${id}`, data, { params: hotelId ? { hotel_id: hotelId } : {} })
export const deleteRanking            = (id, hotelId)    => api.delete(`/admin/rankings/${id}`, { params: hotelId ? { hotel_id: hotelId } : {} })
export const getDailyLeaderboard      = (hotelId, page = 1, limit = 20) =>
  api.get('/admin/rankings/daily-leaderboard', { params: { ...(hotelId ? { hotel_id: hotelId } : {}), page, limit } })
export const getRankingLeaderboard    = (id, hotelId, page = 1, limit = 20) =>
  api.get(`/admin/rankings/${id}/leaderboard`, { params: { ...(hotelId ? { hotel_id: hotelId } : {}), page, limit } })
export const getRankDistribution      = (hotelId) =>
  api.get('/admin/rankings/rank-distribution', { params: hotelId ? { hotel_id: hotelId } : {} })
export const getRankDistributionChildren = ({ hotelId, rankId, from, to, page = 1, limit = 20 } = {}) =>
  api.get('/admin/rankings/rank-distribution/children', { params: {
    ...(hotelId ? { hotel_id: hotelId } : {}),
    ...(rankId ? { rank_id: rankId } : {}),
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    page, limit,
  } })

// ─── Favoritos ──────────────────────────────────────────────────────────────

export const getTopFavorites = (hotelId, limit) =>
  api.get('/admin/favorites/top', { params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...(limit ? { limit } : {}) } })

// ─── Totem (ticket #291 / #288) ────────────────────────────────────────────

// Payload já montado pelo chamador (buildTotemPasswordPayload em
// totemForm.js) -- mesmo formato de setTotemPanel logo abaixo, evita
// duplicar aqui a regra de "hotel_id só entra quando informado".
export const setTotemPassword = (payload) =>
  api.put('/admin/totem/password', payload)

// ─── Painéis do Totem (ticket #292 / #290) ─────────────────────────────────

// hotel_id só entra quando informado -- mesmo padrão de setTotemPassword:
// Gerente nunca manda (backend usa o hotel do próprio token), só Admin
// escolhendo hotel via seletor.
export const getTotemPanel = (hotelId) =>
  api.get('/admin/totem/panel', { params: hotelId ? { hotel_id: hotelId } : {} })

// Ticket #328 -- devolve a senha atual em texto ({ password: string | null }),
// mesmo padrão de hotel_id de getTotemPanel/setTotemPassword acima.
export const getTotemPassword = (hotelId) =>
  api.get('/admin/totem/password', { params: hotelId ? { hotel_id: hotelId } : {} })

export const setTotemPanel = (payload) =>
  api.put('/admin/totem/panel', payload)

// ─── Conversas hóspede↔staff (somente leitura) ─────────────────────────────────

export const listConversations        = (hotelId)        => api.get('/admin/conversations', { params: hotelId ? { hotel_id: hotelId } : {} })
export const getConversationMessages  = (id, hotelId, before) =>
  api.get(`/admin/conversations/${id}/messages`, { params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...(before ? { before } : {}) } })

// ─── Products ─────────────────────────────────────────────────────────────────

export const listProducts   = (hotelId, params) => api.get(`/admin/hotels/${hotelId}/products`, { params })
export const createProduct  = (hotelId, data) => api.post(`/admin/hotels/${hotelId}/products`, data)
export const updateProduct  = (id, data)      => api.put(`/admin/products/${id}`, data)
export const deleteProduct  = (id)            => api.delete(`/admin/products/${id}`)

// ─── Redemptions ───────────────────────────────────────────────────────────────

function redemptionFilterParams({ hotelId, childName, productId, from, to, status } = {}) {
  return {
    ...(hotelId    ? { hotel_id: hotelId }     : {}),
    ...(childName  ? { child_name: childName } : {}),
    ...(productId  ? { product_id: productId } : {}),
    ...(from       ? { from }                  : {}),
    ...(to         ? { to }                    : {}),
    ...(status     ? { status }                : {}),
  }
}

// Fila de resgates aguardando entrega -- alimenta o indicador "Pendências"
// (mesmo padrão de getPendingRankPromotionsCount). Para bank_operator/manager
// o backend ignora hotel_id e usa o hotel do próprio usuário.
export const getPendingRedemptionsCount = (hotelId) =>
  api.get('/admin/redemptions/pending-count', { params: hotelId ? { hotel_id: hotelId } : {} })

export const listRedemptions = ({ page = 1, limit = 20, ...filters } = {}) =>
  api.get('/admin/redemptions', { params: { page, limit, ...redemptionFilterParams(filters) } })

// Total gasto, produtos mais resgatados, gasto médio por criança e
// comparação entre hotéis (ticket L4-11, unificado com a listagem de
// resgates na mesma tela/Histórico de Resgates) -- mesmo formato de filtro
// de listRedemptions.
export const getRedemptionInsights = (filters = {}) =>
  api.get('/admin/redemptions/insights', { params: redemptionFilterParams(filters) })

export const deliverRedemption = (id) => api.post(`/admin/redemptions/${id}/deliver`)
export const cancelRedemption  = (id) => api.post(`/admin/redemptions/${id}/cancel`)

// ─── Banqueiro: Hub Realegres (T2, #298) ───────────────────────────────────────
// Busca por nome escopada ao hotel do Banqueiro -- rota própria (não
// /admin/children), gestos mais estreito que a tela completa de Crianças.
export const searchBankChildren    = (params)  => api.get('/admin/bank/children', { params })
// Lookup exato por RFID (leitor USB HID escaneando a pulseira + Enter) --
// já retorna saldo + pendentes junto, sem chamada extra.
export const lookupBankChildByRfid = (rfid)    => api.get('/admin/bank/children/lookup', { params: { rfid } })
// Depois de escolher um resultado da busca por nome: mesmo shape do lookup
// por RFID acima (child + realegres + pendingRedemptions).
export const getBankChildSummary   = (id)      => api.get(`/admin/bank/children/${id}/summary`)

// "Novo resgate" no balcão (T4, #300): produto + forma de pagamento
// (virtual/físico) escolhidos pelo Banqueiro pra uma criança sem pedido
// prévio do app.
export const bankCreateRedemption  = (childId, { productId, paymentMethod }, idempotencyKey) =>
  api.post(`/admin/bank/children/${childId}/redemptions`, { productId, paymentMethod },
    ...(idempotencyKey ? [{ headers: { 'Idempotency-Key': idempotencyKey } }] : []))

// Converter Realegre virtual em físico (T5, #301): valor livre até o saldo
// disponível, débito novo no ledger `realegres` (motivo dedicado, sem
// produto envolvido).
export const bankConvertRealegres = (childId, amount) =>
  api.post(`/admin/bank/children/${childId}/convert-realegres`, { amount })

// Vínculo de pulseira (T6, #302): tela restrita do Banqueiro pra buscar
// criança OU responsável por nome e vincular o RFID via leitura NFC -- sem
// acesso ao resto do CRUD. Busca de criança reaproveita searchBankChildren
// acima (mesmo endpoint do Hub Realegres); busca de responsável tem rota
// própria (/admin/bank/guardians).
export const searchBankGuardians   = (params)      => api.get('/admin/bank/guardians', { params })
export const bankLinkChildRfid     = (id, rfid)    => api.patch(`/admin/bank/children/${id}/rfid`, { rfid })
export const bankLinkGuardianRfid  = (id, rfid)    => api.patch(`/admin/bank/guardians/${id}/rfid`, { rfid })

// ─── Hotel Day Challenges ─────────────────────────────────────────────────────

// status (ticket L1-10): 'all' (default) | 'past' | 'upcoming' -- filtra o
// histórico de desafios expirados.
export const getEnergyGoal       = (hotelId)       => api.get(`/admin/energy-goals/${hotelId}`)
export const putEnergyGoal       = (hotelId, data) => api.put(`/admin/energy-goals/${hotelId}`, data)
export const listArrivalNotices  = (hotelId)   => api.get('/admin/arrival-notices', { params: hotelId ? { hotel_id: hotelId } : {} })
export const createArrivalNotice = (data)      => api.post('/admin/arrival-notices', data)
export const updateArrivalNotice = (id, data)  => api.put(`/admin/arrival-notices/${id}`, data)
export const deleteArrivalNotice = (id)        => api.delete(`/admin/arrival-notices/${id}`)
export const listChallenges   = (hotelId, status)    => api.get('/admin/challenges', { params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...(status ? { status } : {}) } })
export const createChallenge  = (data)       => api.post('/admin/challenges', data)
export const updateChallenge  = (id, data)   => api.put(`/admin/challenges/${id}`, data)
export const deleteChallenge  = (id)         => api.delete(`/admin/challenges/${id}`)
export const getRecommendedChallengeEnergy = (hotelId, startAt, endAt) =>
  api.get('/admin/challenges/recommended-energy', { params: { hotel_id: hotelId, start_at: startAt, end_at: endAt } })

// ─── Videos ──────────────────────────────────────────────────────────────────

export const listVideos         = ()     => api.get('/admin/videos')
export const listVideoTypes     = ()     => api.get('/admin/videos/types')
export const requestVideoUpload = (data) => api.post('/admin/videos/uploads/request', data)
export const confirmVideoUpload = (id)   => api.post(`/admin/videos/uploads/${id}/confirm`)
export const deleteVideo        = (id)   => api.delete(`/admin/videos/${id}`)

// ─── Entity Media ─────────────────────────────────────────────────────────────

// hotelId (migration 197) -- omitido busca/grava na galeria global (mesmo
// comportamento de sempre); informado busca/grava só a imagem daquele hotel.
export const listEntityMedia    = (entityType, entityId, hotelId) =>
  api.get(`/admin/entity-media/${entityType}/${entityId}`, { params: hotelId ? { hotel_id: hotelId } : {} })
export const addEntityMedia     = (entityType, entityId, data, hotelId) =>
  api.post(`/admin/entity-media/${entityType}/${entityId}`, hotelId ? { ...data, hotel_id: hotelId } : data)
export const setEntityMediaDefault = (mediaId) => api.patch(`/admin/entity-media/${mediaId}/default`)
export const deleteEntityMedia  = (mediaId) => api.delete(`/admin/entity-media/${mediaId}`)

export const uploadEntityImage  = (file) => {
  const fd = new FormData()
  fd.append('image', file)
  return api.post('/admin/entity-media/upload-image', fd)
}

// ─── Ratings ─────────────────────────────────────────────────────────────────

export const getRatingsSummary = (hotelId, startDate, endDate) =>
  api.get('/admin/ratings/summary', { params: { hotel_id: hotelId, start_date: startDate, end_date: endDate } })

export const listEvaluations = (hotelId, fromDate, day, page = 1, limit = 20) =>
  api.get('/admin/evaluations', { params: { hotel_id: hotelId, from_date: fromDate, day: day || undefined, page, limit } })

// ─── Dashboard ────────────────────────────────────────────────────────────────

export const getDashboardChildrenInHotel = (hotelId, date) =>
  api.get('/admin/dashboard/children-in-hotel', { params: { hotel_id: hotelId, date } })
export const getDashboardClassHourPresence = (hotelId, date) =>
  api.get('/admin/dashboard/class-hour-presence', { params: { hotel_id: hotelId, date } })

// ─── Reports ──────────────────────────────────────────────────────────────────

export const getDailySummaryReport = (hotelId, date) =>
  api.get('/admin/reports/daily-summary', { params: { hotel_id: hotelId, date } })

// Monitoramento: adoção da chamada em todos os hotéis (só admin).
export const getChamadaAdoption = (date) =>
  api.get('/admin/reports/chamada-adoption', { params: date ? { date } : {} })

// Relatório da chamada: turmas do dia -> atividades da turma -> crianças da atividade (um nível por chamada).
export const getChamadaReportClasses = ({ hotelId, date }) =>
  api.get('/admin/reports/chamada/classes', { params: { hotel_id: hotelId, ...(date ? { date } : {}) } })
export const getChamadaReportActivities = ({ hotelId, classId }) =>
  api.get('/admin/reports/chamada/activities', { params: { hotel_id: hotelId, class_id: classId } })
export const searchChamadaReportChildren = ({ hotelId, date, q }) =>
  api.get('/admin/reports/chamada/search', { params: { hotel_id: hotelId, q, ...(date ? { date } : {}) } })
export const getChamadaReportChildren = ({ hotelId, activityId }) =>
  api.get('/admin/reports/chamada/children', { params: { hotel_id: hotelId, activity_id: activityId } })

export const getOccupancyReport = ({ hotelId, date, classId }) =>
  api.get('/admin/reports/occupancy', { params: { hotel_id: hotelId, ...(date ? { date } : {}), ...(classId ? { class_id: classId } : {}) } })

// Grade dia × hora (período de até 31 dias); classId opcional.
export const getFlowReport = (hotelId, startDate, endDate, classId) =>
  api.get('/admin/reports/flow', { params: { hotel_id: hotelId, start_date: startDate, end_date: endDate, ...(classId ? { class_id: classId } : {}) } })

// Ticket #278 (spec pai #272): classId já existia (reaproveitado pelo mapa de
// calor); activityTypeId/groupByDayOfWeek são filtros novos, exclusivos do
// mapa de calor hora×atividade -- mesmo endpoint, payload maior.
export const getActivitiesEngagementReport = ({ hotelId, startDate, endDate, classId, activityTypeId, groupByDayOfWeek }) =>
  api.get('/admin/reports/activities-engagement', { params: {
    hotel_id: hotelId, start_date: startDate, end_date: endDate,
    ...(classId ? { class_id: classId } : {}),
    ...(activityTypeId ? { activity_type_id: activityTypeId } : {}),
    ...(groupByDayOfWeek ? { group_by_day_of_week: groupByDayOfWeek } : {}),
  } })

export const getCheckinsReport = ({ hotelId, startDate, endDate, childId, activityId, classId, taualegreId, page, limit }) =>
  api.get('/admin/reports/checkins', { params: {
    hotel_id: hotelId, start_date: startDate, end_date: endDate,
    ...(childId ? { child_id: childId } : {}),
    ...(activityId ? { activity_id: activityId } : {}),
    ...(classId ? { class_id: classId } : {}),
    ...(taualegreId ? { taualegre_id: taualegreId } : {}),
    page, limit,
  } })

export const getTaualegreRanking = (hotelId, startDate, endDate) =>
  api.get('/admin/reports/taualegre-ranking', { params: { hotel_id: hotelId, start_date: startDate, end_date: endDate } })

export const searchChildrenReport = ({ hotelId, name, rfid, room, guardianName, activeOnly, hasAllergy, isPcd, hasRestriction, page, limit }) =>
  api.get('/admin/reports/children-search', { params: {
    hotel_id: hotelId,
    ...(name ? { name } : {}),
    ...(rfid ? { rfid } : {}),
    ...(room ? { room } : {}),
    ...(guardianName ? { guardian_name: guardianName } : {}),
    ...(activeOnly != null ? { active_only: activeOnly } : {}),
    ...(hasAllergy != null ? { has_allergy: hasAllergy } : {}),
    ...(isPcd != null ? { is_pcd: isPcd } : {}),
    ...(hasRestriction != null ? { has_restriction: hasRestriction } : {}),
    page, limit,
  } })

export const getChildDossier = (childId) => api.get(`/admin/reports/children/${childId}/dossier`)

// ─── Color Schemas ────────────────────────────────────────────────────────────

export const listColorSchemas     = ()         => api.get('/admin/color-schemas')
export const createColorSchema    = (data)     => api.post('/admin/color-schemas', data)
export const updateColorSchema    = (id, data) => api.put(`/admin/color-schemas/${id}`, data)
export const setScreenLogoOverride = (id, screenKey, logoKey) => api.put(`/admin/color-schemas/${id}/screen-logo`, { screenKey, logoKey })
export const deleteColorSchema    = (id)       => api.delete(`/admin/color-schemas/${id}`)
// Soft delete (excluir vira soft-delete no backend, mesma chamada acima) +
// listagem/restauração de excluídos -- contrato assumido (nomes de rota não
// confirmados contra o backend no momento em que este código foi escrito,
// ver relatório da tarefa). Ajustar aqui se o backend registrar rotas
// diferentes.
export const listDeletedColorSchemas = ()   => api.get('/admin/color-schemas/deleted')
export const restoreColorSchema      = (id) => api.post(`/admin/color-schemas/${id}/restore`)
export const setActiveColorSchema = ({ childSchemaId, guardianSchemaId } = {}) =>
  api.patch('/admin/app-settings/color-schema', {
    ...(childSchemaId    !== undefined && { childSchemaId }),
    ...(guardianSchemaId !== undefined && { guardianSchemaId }),
  })
export const getAppSettings       = ()         => api.get('/public/app-settings')

// ─── Dev: Error Logs ─────────────────────────────────────────────────────────

export const listErrorLogs = ({ page = 1, limit = 50, status_code, endpoint, date_from, date_to, origin, user_type } = {}) =>
  api.get('/admin/error-logs', { params: { page, limit, status_code, endpoint, date_from, date_to, origin, user_type } })

// ─── Dev: Log viewer — outras fontes (T4) ────────────────────────────────────
// Paths conferidos contra taua-backend/src/routes/admin.routes.ts (+ testes
// admin.*-admin.test.ts) em 2026-08-05, backend sendo construído em paralelo.
// Reconciliar se algum path final divergir -- ver relatório da tarefa.

export const listPermissionChangesLog = (params) => api.get('/admin/permission-change-logs', { params })
export const listChildHolderTransfers = (params) => api.get('/admin/child-holder-transfers', { params })
export const listDestructiveActions   = (params) => api.get('/admin/destructive-actions', { params })
export const listMapActions           = (params) => api.get('/admin/map-actions', { params })
export const listJobRuns              = (params) => api.get('/admin/job-runs', { params })

// ─── Dev: App Versions ───────────────────────────────────────────────────────

export const getAppVersion    = (app)               => api.get(`/admin/app-versions/${app}`)
// effectiveAt (ISO, opcional): vazio = vale já; futuro = só passa a valer nesse horário.
export const updateAppVersion = (app, latest, force, effectiveAt = null) => api.put(`/admin/app-versions/${app}`, { latest, force, effectiveAt })
export const deleteAppVersionHistoryEntry = (id)     => api.delete(`/admin/app-version-history/${id}`)

// Configurações de operação do app do Taualegre (ex.: som da leitura de pulseira na chamada).
export const getOperationSettings    = ()        => api.get('/admin/operation-settings')
export const updateOperationSettings = (payload) => api.put('/admin/operation-settings', payload)

// Limites de tentativas do cadastro público e da busca VOLUX (Configurações do Sistema > Servidor).
// PUT: só os campos enviados; número inteiro de 1 a 10000, ou null para voltar ao padrão.
export const getServerLimits    = ()        => api.get('/admin/server-limits')
export const updateServerLimits = (payload) => api.put('/admin/server-limits', payload)

// Push (ADR-0016 do backend): liga/desliga o envio pelo FCM e guarda a credencial (service account) do Firebase.
// O GET nunca devolve a chave privada, só o status (configurada, origem, projeto, e-mail, data).
// PUT: `fcmEnabled` (boolean) e/ou `serviceAccountJson` (string = salva; null = remove a salva).
export const getPushSettings    = ()        => api.get('/admin/push-settings')
export const updatePushSettings = (payload) => api.put('/admin/push-settings', payload)

// Métricas de push (Comunicação > Métricas de push, só admin): permissão, plataforma, enviados/abertos e falhas.
// `from`/`to` em ISO; hotel opcional. Sem parâmetros o backend usa os últimos 30 dias.
export const getPushMetrics = ({ hotelId, from, to } = {}) =>
  api.get('/admin/metrics/push', {
    params: { ...(hotelId ? { hotel_id: hotelId } : {}), ...(from ? { from } : {}), ...(to ? { to } : {}) },
  })

// ─── Dev: Consulta Volux ─────────────────────────────────────────────────────

export const queryVoluxHospedes = ({
  hotelId, dataInicial, dataFinal, numEspaco, tipoDocumento, numDocumento, crianca, page, pageSize,
} = {}) =>
  api.get('/admin/volux/hospedes', {
    params: { hotelId, dataInicial, dataFinal, numEspaco, tipoDocumento, numDocumento, crianca, page, pageSize },
  })

// ─── Dev: Purga de hotel de teste ───────────────────────────────────────────

export const listTestHotels        = ()   => api.get('/admin/hotels', { params: { is_test: true } })
export const getHotelPurgePreview  = (id) => api.get(`/admin/hotels/${id}/purge-test-data/preview`)
export const purgeTestHotelData    = (id) => api.post(`/admin/hotels/${id}/purge-test-data`)

// ─── Dev: Reset de lançamento (Energia + Realegre, todas as crianças) ───────

export const getEnergyResetPreview   = () => api.get('/admin/children/energy-reset/preview')
export const resetAllChildrenEnergy  = () => api.post('/admin/children/energy-reset')

// ─── Dev: Crash Reporting (Issues, ticket #141) ─────────────────────────────
// Modelo agrupado por fingerprint (ticket #140) -- separado de "Logs de
// Erro" acima, que continua sem alteração.

export const listIssues     = ({ page = 1, limit = 50 } = {}) => api.get('/admin/issues', { params: { page, limit } })
export const getIssueDetail = (id)                             => api.get(`/admin/issues/${id}`)

// Ticket #146 -- segunda aba da mesma tela, mesmo modelo de paginação.
export const listSlowQueries = ({ page = 1, limit = 50 } = {}) => api.get('/admin/slow-queries', { params: { page, limit } })

// Desenvolvimento > Métricas Jornada Taualegre (admin + is_dev); hotel_id opcional.
export const getAccountMetrics = (params = {}) => api.get('/admin/metrics/accounts', { params })

